/* eslint-disable no-return-await, no-console, no-param-reassign, no-trailing-spaces */
import axios from 'axios';
import moment from 'moment';
import helper from '@/_libs/helper';

import order from './_order';

const DATE_TODAY = moment().format('YYYY-MM-DD');

const DATE_YESTERDAY = moment().subtract(1, 'days').format('YYYY-MM-DD');
const DATE_3_DAYS_AGO = moment().subtract(3, 'days').format('YYYY-MM-DD');
const DATE_LASTWEEK = moment().subtract(7, 'days').format('YYYY-MM-DD');

// const DATE_TOMORROW = moment().add(1, 'days').format('YYYY-MM-DD');

const MOCK = {
  user: {
    current: {
      name: 'ณัฐพนธ์ เชาวนศิลป',
      firstName: 'ณัฐพนธ์',
      lastName: 'เชาวนศิลป',

      id: '011023',
      code: '08594111',
      zone: 'NWE',

      email: 'someone@example.com',
      phone: '08594333211',

      username: 'xxxxx',
      imgSrc: 'http://placekitten.com/128/128',

      stat: {
        unpaid: {
          count: 54,
          total: 596800.50,
        },
        dueToday: {
          count: 99,
          total: 10000,
        },
        backOrder: {
          count: 10,
          total: 600780.5,
        },
        awaitShipment: {
          count: 34,
          total: 7567000,
        },
      },

      performance: {
        today: {
          sales: 20000.59,
          commissions: 3167.0,
        },
        thisMonth: {
          sales: 45000,
          goal: 100000,
        },
      },
    },
    unpaidList: [
      {
        id: 0,
        dueDate: DATE_3_DAYS_AGO,
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        sellDate: DATE_LASTWEEK,
      },
      {
        id: 1,
        dueDate: DATE_3_DAYS_AGO,
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        sellDate: DATE_LASTWEEK,
      },
      {
        id: 2,
        dueDate: DATE_YESTERDAY,
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 12453.46,
        sellDate: DATE_3_DAYS_AGO,
      },
      {
        id: 3,
        dueDate: DATE_YESTERDAY,
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        sellDate: DATE_3_DAYS_AGO,
      },
      {
        id: 4,
        dueDate: DATE_YESTERDAY,
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 9198.46,
        sellDate: DATE_3_DAYS_AGO,
      },
    ],
    dueList: [
      {
        id: 1,
        dueDate: DATE_TODAY,
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        sellDate: DATE_LASTWEEK,
      },
      {
        id: 2,
        dueDate: DATE_TODAY,
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        sellDate: DATE_LASTWEEK,
      },
      {
        id: 3,
        dueDate: DATE_TODAY,
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        sellDate: DATE_3_DAYS_AGO,
      },
    ],
    backOrderList: [
      {
        id: 1,
        entryNo: 'AB63111205',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        date: DATE_LASTWEEK,
      },
      {
        id: 2,
        entryNo: 'AB63111206',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        date: DATE_3_DAYS_AGO,
      },
      {
        id: 3,
        entryNo: 'AB63111207',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        date: DATE_YESTERDAY,
      },
      {
        id: 4,
        entryNo: 'AB63111210',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        date: DATE_TODAY,
      },
    ],
    awaitShipmentList: [
      {
        id: 1,
        entryNo: 'AB63111205',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        sellDate: DATE_3_DAYS_AGO,
      },
      {
        id: 2,
        entryNo: 'AB63111206',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        sellDate: DATE_YESTERDAY,
      },
      {
        id: 3,
        entryNo: 'AB63111207',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        sellDate: DATE_TODAY,
      },
      {
        id: 4,
        entryNo: 'AB63111210',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        sellDate: DATE_TODAY,
      },
    ],

    profilePerformance: {
      bestSellings: [
        { id: '01', name: 'ไม้อัดพิเศษ', total: 69000.46 },
        { id: '02', name: 'ไม้อัดธรรมดา', total: 69000.46 },
        { id: '03', name: 'ไม้แปรรูป', total: 69000.46 },
        { id: '04', name: 'กระดาษอัด', total: 69000.46 },
        { id: '05', name: 'ประตู', total: 6659.0 },
        { id: '06', name: 'บอร์ดหนา', total: 5512.0 },
        { id: '07', name: 'บอร์ดเคลือบ/ไฟเมก้า', total: 4320.0 },
        { id: '08', name: 'ลวด', total: 3319.0 },
        { id: '09', name: 'ตะปู/ตะขอ', total: 0 },
        { id: '10', name: 'สังกะสี/โลหะแปรรูป', total: 0 },
        { id: '11', name: 'อลูมีเนียม/อุปกรณ์', total: 0 },
        { id: '12', name: 'ซีไลน์/เหล็กขึ้นรูป', total: 0 },
        { id: '13', name: 'เคมี/น้ำยา', total: 0 },
        { id: '99', name: 'เบ็ดเตล็ด', total: 0 },
      ],
      bestSellingsGroupRatio: [
        { group: '01', value: 0.02 },
        { group: '02', value: 0.02 },
        { group: '03', value: 0.06 },
        { group: '04', value: 0.03 },
        { group: '05', value: 0.02 },
        { group: '06', value: 0.03 },
        { group: '07', value: 0.02 },
        { group: '08', value: 0.15 },
        { group: '09', value: 0.15 },
        { group: '10', value: 0.10 },
        { group: '11', value: 0.30 },
        { group: '12', value: 0.05 },
        { group: '13', value: 0.03 },
        { group: '99', value: 0.02 },
      ],
    },
  },
};

const user = {
  async current() {
    return await helper.call('user.current', {
      success: true,
      data: MOCK.user.current,
    }, async () => {
      const res = await this.myProfile();
      // const res = await axios(helper.path('auth/me/2'));
      const statRes = await this.goalDashboard();

      const { data } = res;
      const stat = statRes.data;

      res.data = {
        ...data,
        zone: (data.area !== null) ? data.area.name : 'ทั้งหมด',

        // TODO: change to real API data
        stat: {
          outstanding: { count: '...', total: 0 },
          dueToday: { count: '...', total: 0 },
          backOrder: { count: '...', total: 0 },
          awaitShipment: { count: '...', total: 0 },
        },

        performance: {
          today: {
            sales: stat.today.total_sale,
            commissions: stat.today.total_commission,
            // sales: 20000.59,
            // commissions: 3167.0,
          },
          thisMonth: {
            sales: stat.month.total_sale,
            goal: stat.month.goal,
            // sales: 45000,
            // goal: 100000,
          },
        },
      };
      return res;
    });
  },

  async myProfile() {
    return await helper.call('user.myProfile', {
    }, async () => {
      const res = await axios(helper.path('auth/me'));
      // console.log(res);

      const SPLITTED_NAME = res.data.name.split(' ');
      res.data = {
        ...res.data,
        name: res.data.name,
        firstName: SPLITTED_NAME[0],
        lastName: SPLITTED_NAME[SPLITTED_NAME.length - 1],
        id: res.data.id,
        code: res.data.employee_id,
        zone: res.data.area ? res.data.area.name : '-',
        email: res.data.email,
        phone: res.data.telephone,
        username: res.data.username,

        // TODO: remove this line when API is fixed,
        imgSrc: (res.data.profile_image_path) ? res.data.profile_image_path.replace('/avatar/', '/storage/avatar/') : '',
        // imgSrc: res.data.profile_image_path,
      };
      return res;
    });
  },

  // Dashboard
  async unpaidList() {
    return await helper.call('user.unpaidList', {
      success: true,
      data: MOCK.user.unpaidList,
    }, async () => await axios(helper.path('current-user/unpaid-list')));
  },
  async dueList(page = 1, filterDate = { from: undefined, to: undefined }) { // eslint-disable-line
    return await helper.call('user.dueList', {
      success: true,
      data: MOCK.user.dueList,
    }, async () => await axios(helper.path('current-user/due-list')));
  },
  async backOrderList(page = 1, filterDate = { from: undefined, to: undefined }) {
    return await helper.call('user.backOrderList', {
      success: true,
      data: [],
    }, async () => {
      const res = await order.list('back_order', page, filterDate.from, filterDate.to);
      return res;
    });
  },
  async awaitShipmentList(page = 1, filterDate = { from: undefined, to: undefined }) {
    return order.list('submitted', page, filterDate.from, filterDate.to, undefined, undefined, false);
  },

  // ProfilePerformance
  async goalDashboard(date = {}, area = -1) {
    if (Object.keys(date).length === 0) {
      if (area !== -1 && area !== '') {
        return await helper.call('user.goalDashboard', {
        }, async () => await axios(helper.path(`salegoal/stats/?area=${area}`)));
      }
      return await helper.call('user.goalDashboard', {
      }, async () => await axios(helper.path('salegoal/stats/')));
    }
    return await helper.call('user.goalDashboard', {
    }, async () => await axios(helper.path(`salegoal/stats?from=${moment(date.from).format('YYYY-MM-DD hh:mm:ss')}&to=${moment(date.to).format('YYYY-MM-DD hh:mm:ss')}`))); // eslint-disable
  },
  async saleGoalLeaderboard() {
    return await helper.call('user.saleGoalLeaderboard', {
    }, async () => await axios(helper.path('salegoal/ranking/')));
  },
  async recentSalesList(date = {}, filterSearch) {
    const from = !date ? undefined : date.from;
    const to = !date ? undefined : date.to;

    return await helper.call('user.recentSalesList', {
      // params...
    }, async () => {
      const res = await axios(helper.path('salegoal/commissionRank'), {
        params: {
          from: from ? moment(from).format('YYYY-MM-DD HH:mm:ss') : undefined,
          to: to ? moment(to).format('YYYY-MM-DD HH:mm:ss') : undefined,
          query: !filterSearch ? undefined : filterSearch,
        },
      });
      return res;
    });
  },
  // async bestSellingsList() {
  //   return await helper.call('user.bestSellingsList', {
  //     success: true,
  //     data: MOCK.user.profilePerformance.bestSellings,
  //   }, async () => await axios(helper.path('user/best-sellings-list')));
  // },
  // async bestSellingsGroupRatio() {
  //   return await helper.call('user.bestSellingsGroupRatio', {
  //     success: true,
  //     data: MOCK.user.profilePerformance.bestSellingsGroupRatio,
  //   }, async () => await axios(helper.path('user/best-sellings-group-ratio')));
  // },

  // Settings
  async changePassword(username, oldPassword, newPassword, newPasswordConfirmation) {
    return await helper.call('user.changePassword', {
      success: true,
      data: MOCK.user.dueList,
    }, async () => {
      const res = await axios.post(
        helper.path('user/changeUsernamePassword'),
        {
          username,
          new_password: newPassword,
          new_password_confirmation: newPasswordConfirmation,
          old_password: oldPassword,
        },
      );
      return res;
    });
  },
  async changeLineToken(token) {
    return await helper.call('user.changeLineToken', {
    }, async () => {
      const res = await axios.post(helper.path('user/changeLineToken'), { line_token: token });
      return res;
    });
  },
  async getLineToken() {
    return await helper.call('user.getLineToken', {
    }, async () => await axios(helper.path('user/getLineToken')));
  },

  async changeAvatar(formData) {
    return await helper.call('user.changeAvatar', {
    }, async () => await axios.post(helper.path('user/changeAvatar'),
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }));
  },
};

export default user;
